const loading = {
    state: {
        area: ''
    },

    mutations: {
        SET_LOADING_AREA: (state, area) => {
            state.area = area
        },
        RESET_LOADING: (state) => {
            state.area = ''
        }
    },

    actions: {
        setLoadingArea({ commit }, area) {
            commit('SET_LOADING_AREA', area)
        },
        resetLoading({ commit }) {
            commit('RESET_LOADING')
        }
    }
}

export default loading



// WEBPACK FOOTER //
// ./src/store/modules/loading.js